import { render, staticRenderFns } from "./LuPosition.vue?vue&type=template&id=0a4a501e"
import script from "./LuPosition.vue?vue&type=script&lang=js"
export * from "./LuPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports